import React from 'react';
import Loadable from 'react-loadable';
import ReactOnRails from 'react-on-rails';

import Loading from '../components/OrganizationSignup2/Loading';
import OrganizationSignup2App from './OrganizationSignup2App';
import ParentSettingsApp from './ParentSettingsApp';
import RouterApp from './ClientRouterApp';
import BottomNavigationApp from './BottomNavigationApp';
import LeftSidenavApp from './LeftSidenavApp';
import FlashNotificationsApp from './FlashNotificationsApp';
import appStore from '../redux/create';

const NewBilling = Loadable({
  loader: () => import('../components/NewBilling/NewBilling'),
  loading: Loading,
});

const OrganizationNotFound = Loadable({
  loader: () => import('appDir/components/Other/OrganizationNotFound'),
  loading: Loading,
});

const NewBillingApp = (props, railsContext) => (
  <NewBilling {...{ ...props, railsContext }} />
);

ReactOnRails.register({
  OrganizationSignup2App,
  ParentSettingsApp,
  RouterApp,
  NewBillingApp,
  BottomNavigationApp,
  LeftSidenavApp,
  FlashNotificationsApp,
  OrganizationNotFoundApp: OrganizationNotFound,
});

ReactOnRails.registerStore({
  appStore,
});
